export const environment = {
  production: false,
  baseUrl: 'https://crown.devbyopeneyes.com',
  apiUrl: 'https://api.crown.devbyopeneyes.com',
  cookieDomainUrl: 'crown.devbyopeneyes.com',
  env: 'local',
  CAPTCHA_SITE_KEY: '6LfibjsrAAAAAF_WEH9LODomYZg2r2_XFjbsbWEU',
  showCaptcha: false,
  psiUrl: null,
  learnUponUrl: 'https://oeccitest.learnupon.com',
  STRIPE_PK: 'pk_test_51NR3mxGua2SjD0hdHuV8V43iuxQ9t3YrxvBT53y70DXSXiZRXdPCIPUHKqEYYMErGhP8lZ1qUWyNeGGIkLiYRLfD00i63NFrQw',
  AM_CHARTS_LICENSE_KEY: 'AM5C236795548',
};
